import BaseView from '../core/baseView';

export default BaseView.extend({
  initialize: function(options) {
    /*
        Store additional model when required
         */
    if (options && options.additionalModel) {
      this.additionalModel = options.additionalModel;
    }

    this.preInit();
    this.localInitialize();
    this.postInit();
  },

  preInit: function() {},

  localInitialize: function() {},

  postInit: function() {}
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/BaseSliderView.js
 **/